import dashboard from './dashboard';
import dynamic from './dynamic';
import editor from './editor';
import globals from './globals';
import pages from './pages';
import settings from './settings';
import redirects from './redirects';
import users from './users';
import storage from './storage';
import metrics from './metrics';

// eslint-disable-next-line prettier/prettier
export default [
  dashboard,
  dynamic,
  editor,
  globals,
  pages,
  settings,
  redirects,
  users,
  storage,
  metrics,
];
